import { UpdateOrganization, Organization, isOrganization } from 'core/types';
import gql from 'graphql-tag';
import { queryWithError } from 'lib/graphql-client';
import { OrganizationFragment } from '../fragments';

const updateQuery = gql`
  mutation updateOrganization($draft: UpdateOrganization!) {
    manage {
      updateOrganization(org: $draft) {
        ...OrganizationFragment
      }
    }
  }
  ${OrganizationFragment}
`;

export async function updateOrganization(
  draft: UpdateOrganization,
): Promise<Organization> {
  const res = await queryWithError(updateQuery, { draft });
  if (res.errors) {
    // TODO handle error
    throw new Error('Could not update organization');
  }

  if (!res.data || !res.data.manage || !res.data.manage.updateOrganization) {
    throw new Error(
      'Could not find res.data.manage.updateOrganization in return data',
    );
  }

  if (!isOrganization(res.data.manage.updateOrganization)) {
    throw new Error(
      'Returned res.data.manage.updateOrganization does not conform to Organization',
    );
  }

  return res.data.manage.updateOrganization;
}

export function noop(): void {
  // yay linter
}
